import React from 'react'
import './TimeLine2.css'

const TimeLine = ({ id, stats, buttonName }) => (
  <section id="timeline1" class="pt-5 pr-5 pl-5">
    <div className="otm-home1 traveltime">
      <div className="row">
        <div className="col-sm-12">
          <p className="pag-line-trust">EVENT TIMELINE</p>
          {/* <div className="wrap">
            <div className="top">
              <div className="item">
                <div className="top-txt">2024</div>
              </div>
            </div>
            <div className="line" />
            <div className="bottom">
              <div className="placeholder" />                         
              <div className="item">
                <div className="timelineheding">TTF Patna</div>
                <div className="timelinetxt">22 & 23 October</div>
              </div>
            </div>
          </div> */}
          <div className="wrap1">
            <div className="top d-none d-sm-flex">
              <div className="item">
                <div className="top-txt2">2026</div>
              </div>
              <div className="item d-none d-sm-block" style={{ visibility: 'hidden' }}></div>
              <div className="item d-none d-sm-block" style={{ visibility: 'hidden' }}></div>
              <div className="item d-none d-sm-block" style={{ visibility: 'hidden' }}></div>
              <div className="item d-none d-sm-block" style={{ visibility: 'hidden' }}></div>
              <div className="item d-none d-sm-block" style={{ visibility: 'hidden' }}></div>
              <div className="item d-none d-sm-block" style={{ visibility: 'hidden' }}></div>
              <div className="item">
                <div className="top-txt2">2027</div>
              </div>
            </div>
            <div className="line1" />
            <div className="bottom1">
            <div className="top-txt2 d-block d-sm-none mobile-year-header">2026</div>
            <div className="item1">
              <div className="timelineheding">TTF Kolkata</div>
              <div className="timelinetxt">10, 11 & 12 July</div>
            </div>
            <div className="item1">
              <div className="timelineheding">TTF Ahmedabad</div>
              <div className="timelinetxt">06, 07 & 08 August</div>
            </div>
            <div className="item1">
              <div className="timelineheding">TTF Mumbai</div>
              <div className="timelinetxt">20, 21 & 22 August</div>
            </div>
            <div className="item1">
              <div className="timelineheding">BLTM</div>
              <div className="timelinetxt">02, 03 & 04 September</div>
            </div>
            <div className="item1">
              <div className="timelineheding">TTF Hyderabad</div>
              <div className="timelinetxt">09, 10 & 11 October</div>
            </div>
            <div className="item1">
              <div className="timelineheding">WTE Miami</div>
              <div className="timelinetxt">27 & 28 October</div>
            </div>
            <div className="top-txt2 d-block d-sm-none mobile-year-header">2027</div>
            <div className="item1 dotted-item">
              <div className="timelineheding">OTM</div>
              <div className="timelinetxt">01, 02 & 03 February</div>
            </div>
            <div className="placeholder1 dotted-item" />
          </div>
          </div>

        </div>
      </div>
    </div>
  </section>
)

export default TimeLine
